import { PropsWithClassName } from 'lib-shared-types-utils';

type DixaLogoProps = {
  /** The color of the logo. */
  readonly color?: string;
} & PropsWithClassName;

/** Represents the Dixa logo. */
export const DixaLogo = ({
  className,
  color = 'currentColor',
}: DixaLogoProps): JSX.Element => (
  <svg className={className} viewBox="0 0 44 46" data-test-id="loader-logo">
    <path
      d="M28.259 23.781l-4.707 2.638a.849.849 0 01-1.16-.307l-5.426-9.209c-.255-.4-.093-.895.302-1.131l4.707-2.638c3.014-1.695 6.84-.706 8.579 2.238.58.966.835 2.026.835 3.062a6.158 6.158 0 01-3.13 5.347zM41.43 9.225C36.235.392 24.711-2.623 15.691 2.488L.85 10.873a1.668 1.668 0 00-.626 2.285l12.87 21.81c.278.472.417.99.417 1.531v9.069c0 .329.371.541.672.376l20.36-11.517c6.029-3.416 9.414-9.634 9.414-15.993 0-3.133-.811-6.312-2.527-9.209z"
      fill={color}
    />
  </svg>
);
